/* eslint-disable no-unused-vars */
import { Button, IconButton, TextField, MenuItem, Typography, Tooltip, } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, DateRange } from '@material-ui/icons';
import EventBusyOutlinedIcon from '@material-ui/icons/EventBusyOutlined';
import RedeemIcon from '@material-ui/icons/Redeem';
import React, { useEffect, useState } from 'react';
import { NavigationWrapper, RightWrapper, StyledTextField, Wrapper, } from './CalendarToolBar.Styles';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ViewListIcon from '@material-ui/icons/ViewList';
export var CalendarToolBar = function (props) {
    var _a = React.useState({}), updateState = _a[1];
    var forceUpdate = React.useCallback(function () { return updateState({}); }, []);
    var _b = React.useState(false), agendaView = _b[0], setAgendaView = _b[1];
    var _c = useState(false), openDate = _c[0], setOpenDate = _c[1];
    var _d = useState(false), holidayStatus = _d[0], setHolidayStatus = _d[1];
    var _e = useState(''), startDate = _e[0], setStartDate = _e[1];
    var _f = useState(''), endDate = _f[0], setEndDate = _f[1];
    var _g = useState(function () { return ['holiday']; }), formats = _g[0], setFormats = _g[1];
    var goToBack = function () {
        props.onNavigate('PREV');
    };
    var goToNext = function () {
        props.onNavigate('NEXT');
        var localizer = props.localizer;
    };
    var goToCurrent = function () {
        props.onNavigate('TODAY');
    };
    useEffect(function () {
        if (props.view === 'agenda') {
            setAgendaView(true);
        }
        else {
            setAgendaView(false);
        }
    }, [agendaView]);
    var handleViewChange = function (value) {
        props.onView(value);
    };
    var handleClose = function () {
        setOpenDate(false);
    };
    var handleToggleChange = function () {
        setHolidayStatus(!holidayStatus);
    };
    var setAgendaInterval = function (startDate, endDate) {
        props.changeDateRange(startDate, endDate);
        if (startDate) {
            props.onNavigate('DATE', new Date(startDate.replace(/-/g, '/')));
            props.changeDateRange(startDate, endDate);
        }
        handleClose();
    };
    return (React.createElement(Wrapper, null,
        React.createElement(NavigationWrapper, null,
            React.createElement(IconButton, { color: 'primary', onClick: function () { return goToBack(); } },
                React.createElement(ArrowBackIos, null)),
            React.createElement(Button, { onClick: function () { return goToCurrent(); }, color: 'primary' }, "Today"),
            React.createElement(IconButton, { color: 'primary', onClick: function () { return goToNext(); } },
                React.createElement(ArrowForwardIos, null)),
            agendaView ? (React.createElement(Tooltip, { title: 'Set Interval', placement: 'top' },
                React.createElement(IconButton, { color: 'primary', onClick: function () {
                        setOpenDate(true);
                    } },
                    React.createElement(DateRange, null)))) : null,
            React.createElement(Tooltip, { title: 'Holidays Only', placement: 'top' },
                React.createElement(IconButton, { color: 'primary', onClick: function () {
                        props.setFilter('Holidays');
                    } },
                    React.createElement(RedeemIcon, null))),
            React.createElement(Tooltip, { title: 'All Events', placement: 'top' },
                React.createElement(IconButton, { color: 'primary', onClick: function () {
                        props.setFilter('Schedule Name');
                    } },
                    React.createElement(ViewListIcon, null)))),
        React.createElement(Dialog, { open: openDate, onClose: function () { return handleClose(); }, "aria-labelledby": 'alert-date', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-date' }, "Date Interval"),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { id: 'date', label: 'Start Date', defaultValue: new Date(props.dateRange.start).toLocaleDateString('en-CA'), type: 'date', onChange: function (e) {
                        setStartDate(e.target.value);
                    }, InputLabelProps: {
                        shrink: true
                    } })),
            React.createElement(DialogContent, null,
                React.createElement(TextField, { id: 'date', label: 'End Date', defaultValue: new Date(props.dateRange.end).toLocaleDateString('en-CA'), type: 'date', onChange: function (e) {
                        setEndDate(e.target.value);
                    }, InputLabelProps: {
                        shrink: true
                    } })),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setAgendaInterval(startDate, endDate); }, color: 'primary' }, "Confirm"))),
        agendaView ? (React.createElement(Typography, { variant: 'h6' }, new Date(props.dateRange.start).toLocaleDateString() + " - " + new Date(props.dateRange.end).toLocaleDateString())) : (React.createElement(Typography, { variant: 'h6' }, props.label)),
        React.createElement(RightWrapper, null,
            React.createElement(StyledTextField, { select: true, margin: 'dense', value: props.view, onChange: function (e) { return handleViewChange(e.target.value); } }, props.views.map(function (value) { return (React.createElement(MenuItem, { key: value, value: value }, value.toUpperCase().replace(/_/g, ' '))); })),
            React.createElement(Tooltip, { title: 'Manage Holidays', placement: 'top' },
                React.createElement(IconButton, { disabled: props.openSidebar, onClick: function () { return props.handleSideBar(); } },
                    React.createElement(EventBusyOutlinedIcon, null))))));
};
CalendarToolBar.defaultProps = {
// bla: 'test',
};
//# sourceMappingURL=CalendarToolBar.js.map